import React from 'react';
import { ElogioUI } from './ui';

export const ElogioScreen: React.FC = (): JSX.Element => {
  return <ElogioUI />;
};
